import { i as e, r as t, t as n } from "./dist-By11B3Nf.js";
import { a as r, n as i } from "./dist-7tgynhKG.js";
import { a, i as o, l as s, n as c, o as l, r as u, t as d } from "./es2015-Dfq2CQHn.js";
import { t as f } from "./dist-B3lndwlS.js";
import { t as p } from "./dist-CUIQpIad.js";
import { i as m, n as h, r as g, t as _ } from "./dist-8NAz9rgL.js";
import * as v from "react";
import { jsx as y } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-popover@1.1.20_@types+react-dom@19.2.3_@types+react@19.2.17__@types+rea_4381ee013dbe6236fb5dc3817fe19cea/node_modules/@radix-ui/react-popover/dist/index.mjs
var b = Object.defineProperty, x = (e, t) => b(e, "name", {
	value: t,
	configurable: !0
}), S = "Popover", [C, w] = e(S, [m]), T = m(), [E, D] = C(S), O = /* @__PURE__ */ x((e) => {
	let { __scopePopover: t, children: r, open: i, defaultOpen: a, onOpenChange: o, modal: c = !1 } = e, l = T(t), u = v.useRef(null), [d, f] = v.useState(!1), [p, m] = n({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: S
	});
	return /* @__PURE__ */ y(g, {
		...l,
		children: /* @__PURE__ */ y(E, {
			scope: t,
			contentId: s(),
			triggerRef: u,
			open: p,
			onOpenChange: m,
			onOpenToggle: v.useCallback(() => m((e) => !e), [m]),
			hasCustomAnchor: d,
			onCustomAnchorAdd: v.useCallback(() => f(!0), []),
			onCustomAnchorRemove: v.useCallback(() => f(!1), []),
			modal: c,
			children: r
		})
	});
}, "Popover"), k = "PopoverAnchor", A = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = D(k, n), a = T(n), { onCustomAnchorAdd: o, onCustomAnchorRemove: s } = i;
	return v.useEffect(() => (o(), () => s()), [o, s]), /* @__PURE__ */ y(_, {
		...a,
		...r,
		ref: t
	});
}, "PopoverAnchor")), j = "PopoverTrigger", M = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ x(function(e, n) {
	let { __scopePopover: i, ...a } = e, o = D(j, i), s = T(i), c = r(n, o.triggerRef), l = /* @__PURE__ */ y(f.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": o.open,
		"aria-controls": o.open ? o.contentId : void 0,
		"data-state": U(o.open),
		...a,
		ref: c,
		onClick: t(e.onClick, o.onOpenToggle)
	});
	return o.hasCustomAnchor ? l : /* @__PURE__ */ y(_, {
		asChild: !0,
		...s,
		children: l
	});
}, "PopoverTrigger")), N = "PopoverPortal", [P, F] = C(N, { forceMount: void 0 }), I = /* @__PURE__ */ x((e) => {
	let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = D(N, t);
	return /* @__PURE__ */ y(P, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ y(p, {
			present: n || a.open,
			children: /* @__PURE__ */ y(o, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "PopoverPortal"), L = "PopoverContent", R = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let n = F(L, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = D(L, e.__scopePopover);
	return /* @__PURE__ */ y(p, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ y(B, {
			...i,
			ref: t
		}) : /* @__PURE__ */ y(V, {
			...i,
			ref: t
		})
	});
}, "PopoverContent")), z = i("PopoverContent.RemoveScroll"), B = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ x(function(e, n) {
	let i = D(L, e.__scopePopover), a = v.useRef(null), o = r(n, a), s = v.useRef(!1);
	return v.useEffect(() => {
		let e = a.current;
		if (e) return d(e);
	}, []), /* @__PURE__ */ y(c, {
		as: z,
		allowPinchZoom: !0,
		children: /* @__PURE__ */ y(H, {
			...e,
			ref: o,
			trapFocus: i.open,
			disableOutsidePointerEvents: !0,
			onCloseAutoFocus: t(e.onCloseAutoFocus, (e) => {
				e.preventDefault(), s.current || i.triggerRef.current?.focus();
			}),
			onPointerDownOutside: t(e.onPointerDownOutside, (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
				s.current = r;
			}, { checkForDefaultPrevented: !1 }),
			onFocusOutside: t(e.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 })
		})
	});
}, "PopoverContentModal")), V = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let n = D(L, e.__scopePopover), r = v.useRef(!1), i = v.useRef(!1);
	return /* @__PURE__ */ y(H, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let a = t.target;
			n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	});
}, "PopoverContentNonModal")), H = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, disableOutsidePointerEvents: s, onEscapeKeyDown: c, onPointerDownOutside: d, onFocusOutside: f, onInteractOutside: p, ...m } = e, g = D(L, n), _ = T(n);
	return u(), /* @__PURE__ */ y(a, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: o,
		children: /* @__PURE__ */ y(l, {
			asChild: !0,
			disableOutsidePointerEvents: s,
			onInteractOutside: p,
			onEscapeKeyDown: c,
			onPointerDownOutside: d,
			onFocusOutside: f,
			onDismiss: () => g.onOpenChange(!1),
			deferPointerDownOutside: !0,
			children: /* @__PURE__ */ y(h, {
				"data-state": U(g.open),
				role: "dialog",
				id: g.contentId,
				..._,
				...m,
				ref: t,
				style: {
					...m.style,
					"--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
					"--radix-popover-content-available-width": "var(--radix-popper-available-width)",
					"--radix-popover-content-available-height": "var(--radix-popper-available-height)",
					"--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
					"--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
				}
			})
		})
	});
}, "PopoverContentImpl"));
function U(e) {
	return e ? "open" : "closed";
}
x(U, "getState");
var W = O, G = A, K = M, q = I, J = R;
//#endregion
export { K as a, W as i, J as n, q as r, G as t };

//# sourceMappingURL=dist-Bbyy0Cx5.js.map